/* eslint-disable @typescript-eslint/no-explicit-any */
import { Td, Text, Tooltip, Badge, Box } from '@chakra-ui/react';

const BodyTable = ({
  id_plan,
  name_plan,
  value_plan,
  count_clients_active,
}: {
  id_plan: string;
  name_plan: string;
  value_plan: number | string;
  count_clients_active: number;
}) => {
  const formattedValue = (() => {
    if (value_plan == null || value_plan === '') return 'R$ 0,00';

    let numeric: number;

    if (typeof value_plan === 'number') {
      // Já é número normalizado (ex: 123.45)
      numeric = value_plan;
    } else {
      const raw = String(value_plan);
      // remove prefixos como "R$" e espaços
      const cleaned = raw.replace(/R\$\s*/i, '').trim();
      // trata formatos com milhar e vírgula decimal (ex: 1.234,56)
      const normalized = cleaned.replace(/\./g, '').replace(',', '.');
      numeric = parseFloat(normalized);
    }

    if (Number.isNaN(numeric)) return 'R$ 0,00';

    return numeric.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  })();
  return (
    <>
      <Td
        textAlign="center"
        py={1}
        maxW="70px"
        width="70px"
        borderRight="1px solid"
        borderColor="gray.200"
        position="sticky"
        left={0}
        bg="white"
        zIndex={6}
      >
        <Tooltip label="Identificador único do plano ERP no sistema" placement="top">
          <Text fontSize="xs" fontWeight="bold" color="gray.600" maxW="50px">
            {id_plan}
          </Text>
        </Tooltip>
      </Td>

      {/* Nome da Categoria */}
      <Td
        py={1}
        position="sticky"
        left="50px"
        bg="white"
        zIndex={6}
        borderRight="1px solid"
        borderColor="gray.200"
        maxW="150px"
        width="150px"
      >
        <Text
          textAlign="left"
          fontSize="xs"
          fontWeight="medium"
          color="gray.800"
          maxW="100%"
          lineHeight="1.1"
          wordBreak="break-word"
          whiteSpace="normal"
          noOfLines={2}
        >
          {name_plan}
        </Text>
      </Td>

      {/* Valor do plano */}
      <Td
        textAlign="center"
        py={1}
        maxW="100px"
        width="100px"
        minW="100px"
        borderRight="1px solid"
        borderColor="gray.200"
        position="sticky"
        left="270px"
        bg="white"
        zIndex={6}
      >
        <Tooltip label="Valor mensal do plano ERP" placement="top">
          <Box
            bg="blue.50"
            border="1px solid"
            borderColor="blue.200"
            color="blue.700"
            px={1.5}
            py={1}
            borderRadius="sm"
            fontSize="xs"
            fontWeight="semibold"
            textAlign="center"
            _hover={{
              bg: 'blue.100',
              borderColor: 'blue.300',
            }}
            transition="all 0.2s"
          >
            {formattedValue}
          </Box>
        </Tooltip>
      </Td>

      {/* Usuários Ativos */}
      <Td textAlign="center" py={1} maxW="60px" width="60px" borderRight="1px solid" borderColor="gray.200">
        <Tooltip label="Total de usuários ativos atualmente neste plano ERP" placement="top">
          <Badge colorScheme="green" fontSize="xs" variant="solid" textAlign="center" px={1}>
            {count_clients_active?.toLocaleString('pt-BR') || '0'}
          </Badge>
        </Tooltip>
      </Td>
    </>
  );
};

export default BodyTable;
